const AppBlockingLoader = () => {
  return (
    <div className="bg-base-100 fixed top-0 right-0 bottom-0 left-0 z-10 flex items-center justify-center">
      <span className="loading loading-spinner loading-lg"></span>
    </div>
  );
};

export default AppBlockingLoader;
